import { createFileRoute, notFound } from '@tanstack/react-router';
import { FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { CityLedgerPage } from '@mews-commander/modules/src/modules/finance';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Ledgers/City')({
    component: CityLedgerPage,
    loader: async ({ context: { ensureQueryData, featureFlagService } }) => {
        const data = await ensureQueryData('accountingConfigurations', 'get', {});

        const isNewCityLedgerEnabled = !!data?.accountingConfiguration?.options?.receivableTrackingEnabled;
        const goodDataLedgersEnabled = featureFlagService.hasFlag(FeatureFlag.newFinanceLedgersEnabled);

        if (!isNewCityLedgerEnabled && !goodDataLedgersEnabled) {
            throw notFound();
        }
    },

    staticData: {
        owner: MewsTeam.Accounting,
        type: RouteType.Frontend,
        title: TextKey.CityLedger,
        routeName: RouteName.FinanceCityLedger,
    },
});
